/* Signature Pergolas — lightweight UI behaviour (no dependencies) */
(function () {
  'use strict';
  if (window.__spInit) return;
  window.__spInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var body = document.body;

    function open(el) { if (el) { el.classList.add('is-open'); body.style.overflow = 'hidden'; } }
    function close(el) { if (el) { el.classList.remove('is-open'); body.style.overflow = ''; } }

    // Generic open/close via data attributes
    document.querySelectorAll('[data-sp-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(document.getElementById(btn.getAttribute('data-sp-open')));
      });
    });
    document.querySelectorAll('[data-sp-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-sp-close');
        close(target ? document.getElementById(target) : btn.closest('.is-open'));
      });
    });

    // Click on overlay backdrop closes; clicks inside the panel do not
    document.querySelectorAll('.sp-overlay, .sp-search').forEach(function (ov) {
      ov.addEventListener('click', function (e) {
        if (e.target === ov) close(ov);
      });
    });

    // Escape closes everything
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.is-open').forEach(close);
      }
    });

    // Sticky header shrink + hide announcement on scroll
    var header = document.querySelector('[data-sp-header]');
    var ann = document.querySelector('[data-sp-ann]');
    if (header) {
      var onScroll = function () {
        var s = window.scrollY > 50;
        header.classList.toggle('is-scrolled', s);
        if (ann) ann.style.maxHeight = s ? '0px' : (ann.scrollHeight + 'px');
        if (ann) ann.style.opacity = s ? '0' : '1';
      };
      if (ann) { ann.style.overflow = 'hidden'; ann.style.transition = 'max-height .35s ease,opacity .3s ease'; }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();
